import { Router, RouterStateSnapshot } from '@angular/router';

export function isEqual(a: unknown, b: unknown): boolean {
	return JSON.stringify(a) === JSON.stringify(b);
}

export function formatDateInYYYYMMDD(date: Date): string {
	const year = date.getFullYear();
	const month = String(date.getMonth() + 1).padStart(2, '0');
	const day = String(date.getDate()).padStart(2, '0');
	return `${year}-${month}-${day}`;
}

export function createTomorrowDate(): Date {
	const today = new Date();
	const tomorrow = new Date(today);
	tomorrow.setDate(today.getDate() + 1);
	return tomorrow;
}

export function parseStarName(name: string): number {
	return parseInt(name, 10);
}

export function formatUrlName(name: string): string {
	return name
		.toLowerCase()
		.replace(/[čć]/g, 'c')
		.replace(/š/g, 's')
		.replace(/ž/g, 'z')
		.replace(/&/g, 'and')
		.replace(/[,'*]/g, '')
		.replace(/\s+/g, '-')
		.replace(/\//g, '-')
		.replace(/\(([^)]+)\)/g, '-$1')
		.replace(/-+/g, '-')
		.replace(/^-|-$/g, '');
}

export function formatPhoneNumber(phone: string): string {
	if (phone.length < 12 || phone.length > 13) {
		return phone;
	}

	const first = phone.slice(0, 4);
	const second = phone.slice(4, 6);
	const middleLength = phone.length - 9;
	const middle = phone.slice(6, 6 + middleLength);
	const last = phone.slice(-3);

	return `${first} ${second} ${middle} ${last}`;
}

export function getUrlWithoutParams(router: Router): string {
	const urlTree = router.parseUrl(router.url);
	urlTree.queryParams = {};
	urlTree.fragment = null; // optional
	return urlTree.toString();
}

export function getNormalizedRouteUrl(lang: string, routeUrl: string): string {
	// Remove the language segment from the routeUrl if present at the start
	const langPrefix = `/${lang}`;
	let normalizedUrl = routeUrl.startsWith(langPrefix) ? routeUrl.slice(langPrefix.length) : routeUrl;

	// Remove trailing slash if present (except for root '/')
	if (normalizedUrl.endsWith('/') && normalizedUrl.length > 1) {
		normalizedUrl = normalizedUrl.slice(0, -1);
	}

	// Remove leading slash
	if (normalizedUrl.startsWith('/')) {
		normalizedUrl = normalizedUrl.slice(1);
	}

	return normalizedUrl || 'home';
}

export function getLanguage(state: RouterStateSnapshot): string {
	return state.url.split('/').filter(Boolean)[0];
}

export function stripTrailingSlash(url: string): string {
	return url.endsWith('/') && url.length > 1 ? url.slice(0, -1) : url;
}

export function parseStringToNumber(value: string | number | null): number | null {
	if (value === null) {
		return null;
	}
	const parsed = Number.parseInt(value as string, 10);
	return Number.isNaN(parsed) ? null : parsed;
}
